import React, {Fragment, useState} from "react";
import {Dialog, Transition} from "@headlessui/react";

interface SortDataProps {
    orderList: Array<{ key: string; name: string }>;
    setOrder: React.Dispatch<React.SetStateAction<string>>;
    initialSelected?: string | undefined;
}

export const SortData: React.FC<SortDataProps> = ({
                                                      orderList,
                                                      setOrder,
                                                      initialSelected,
                                                  }) => {
    const [selected, setSelected] = useState(initialSelected ? initialSelected : "");

    const handleClick = (order: string) => {
        setOrder(order);
        setSelected(order);
    };

    return (
        <>
            {/*Web View*/}
            <div className="hidden lg:flex w-full gap-4">
                {orderList.length > 0 && (
                    orderList.map((item, index) => {
                        return (
                            <div
                                key={index}
                                className={`text-xs cursor-pointer ${selected === item.key ? "text-customColor font-bold" : "font-normal text-gray-500"}`}
                                onClick={() => handleClick(`${item.key}`)}
                            >
                                {item.name}
                            </div>
                        )
                    })
                )}
            </div>
        </>
    );
};